import moment from 'moment';
import { EMARPOLDocuments, TMARPOLTank } from '../../marpol/@types';
import {
    ECRBRecordCode,
    ECRBRecordState,
    TCRBCommonData,
    TCRBCommonFields,
    ESubstanceCategories,
    TCRBPlace,
} from '../@types';

export type TCRBItem26 = {
    timeOfOccurence: string;
};

export type TCRBItem26P1 = {
    placeOfBallast: TCRBPlace;
};

export type TCRBItem27 = {
    tanks: TCRBItem27Tank[];
};

export type TCRBItem27Tank = {
    selectedTank: TMARPOLTank;
    transferQuantity: number;
    newQuantity: number;
    substance: string;
    catgeory: ESubstanceCategories;
};
export type TCRBItem27P1 = {
    totalDischargeQuantityOfTanks: number;
};

export type TCRBItem28 = {
    circumstances: string;
};

export type TCRBI1 = TCRBCommonFields &
    TCRBCommonData & {
        id: string;
        recordCode: ECRBRecordCode.CRBI;
        item26: TCRBItem26;
        item26P1: TCRBItem26P1;
        item27: TCRBItem27;
        item27P1: TCRBItem27P1;
        item28: TCRBItem28;
    };

export type TCRBI = TCRBI1;

const CRBI_DEFAULTS: {
    I: TCRBI1;
} = {
    I: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.CRB,
        state: ECRBRecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item26: {
            timeOfOccurence: '',
        },
        item26P1: {
            placeOfBallast: {
                place: 'IN_PORT',
                portName: '',
            },
        },
        item27: {
            tanks: [],
        },
        item27P1: {
            totalDischargeQuantityOfTanks: 0,
        },
        item28: {
            circumstances: '',
        },
        recordCode: ECRBRecordCode.CRBI,
    },
};

export { CRBI_DEFAULTS };
